import { queryOptions } from "@tanstack/react-query";
import { apiUrl } from "@/lib/api-url";

export interface HomepageTopic {
  tag: string;
  label: string;
  description: string | null;
  imageUrl: string;
}

export interface HomepageTopicsEnvelope {
  topics: HomepageTopic[];
}

/**
 * SSR-safe public query for the curated homepage topic bento. apiUrl() resolves
 * to loopback server-side (a bare relative fetch throws under Bun); stable key
 * for invalidation matching.
 */
export const homepageTopicsQuery = queryOptions({
  queryKey: ["homepage-topics", "public"] as const,
  queryFn: async (): Promise<HomepageTopicsEnvelope> => {
    const res = await fetch(apiUrl("/api/homepage-topics"));
    if (!res.ok) throw new Error("Failed to fetch homepage topics");
    return res.json();
  },
});
